
import { apiUrl, apiFetch, wsUrl } from "./api";

// fetch(apiUrl("/api/news-usage"));
// await apiFetch("/api/news", { method: "POST", body: { ... } });


export async function fetchNews({ mode, filters, setArticles, setSelected }) {
    const isTopHeadlines = mode === "top";
    const params = new URLSearchParams();
    const articleKey =
      mode === "top" ? "newsCompare:topHeadlines" : "newsCompare:detailedSearch";
    const filterKey =
      mode === "top" ? "newsCompare:filtersTop" : "newsCompare:filtersSearch";
  
    params.append("mode", isTopHeadlines ? "top" : "search");
  
    if (isTopHeadlines) {
      if (filters.category) params.append("category", filters.category);
      if (filters.countries.length > 0) params.append("country", filters.countries[0]);
    } else {
      if (filters.keywords.length > 0) params.append("keywords", filters.keywords.join(","));
      if (filters.countries.length > 0) params.append("countries", filters.countries.join(","));
      if (filters.dateRange) params.append("dateRange", filters.dateRange);
      if (filters.from) params.append("from", filters.from);
      if (filters.to) params.append("to", filters.to);
      if (filters.match) params.append("match", filters.match);
      if (filters.category) params.append("category", filters.category);
    }
  
    try {
      const res = await fetch(apiUrl(`/api/news?${params.toString()}`));
      const data = await res.json();
      const articles = data.articles || [];
      setArticles(articles);
      setSelected(articles[0] || null);
      localStorage.setItem(articleKey, JSON.stringify(articles));
      localStorage.setItem(filterKey, JSON.stringify(filters));
    } catch (err) {
      console.error("❌ Failed to fetch news:", err);
    }
  }
  export async function fetchNewsUsage() {
  try {
    const res = await fetch(apiUrl("/api/news-usage"), { cache: "no-store" });
    if (!res.ok) throw new Error(`Usage request failed: ${res.status}`);

    const { resetAtUtc, limit, remaining, used } = await res.json();

    const resetLocal = new Date(resetAtUtc);
    const now = new Date();

    const sameLocalDay =
      resetLocal.getFullYear() === now.getFullYear() &&
      resetLocal.getMonth() === now.getMonth() &&
      resetLocal.getDate() === now.getDate();

    const resetDay = sameLocalDay ? "today" : "tomorrow";

    // Force 12-hour with am/pm in the user's local timezone
    const resetTime = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      // timezone remains the user's local zone by default
    }).format(resetLocal).toLowerCase(); // e.g., "2:00 am"

    return {
      resetDay,
      resetTime,
      limit: Number(limit),
      remaining: Number(remaining),
      used: Number(used),
    };
  } catch (err) {
    console.error("❌ Failed to fetch usage:", err);
    return {
      resetDay: "today",
      resetTime: "12:00 am",
      limit: 0,
      remaining: 0,
      used: 0,
    };
  }
}
